import React from "react";
import PropTypes from "prop-types";
import Style from "./modal.module.scss";
import "./modalstyle.scss";
import CommonModal from "./CommonModal";
export const ThankYouModal = ({
  isOpen,
  toggle,
  title,
  content,
  btnContent
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title=" "
      modalClassName={`${Style.xeroModal} modal-dialog-centered thanks-modal-wrap`}
      headerClassName={Style.creditModalHeader}
      hideFooter
    >
      <div
        className={`${Style.xeroModalContent} ${Style.thankModalContent} modal-content text-center thankmodalcontent-wrap`}
      >
        {title && <h2>{title}</h2>}
        {content && <p>{content}</p>}
        {btnContent && (
          <button className="btn btn-primary no-link-hover">
            {btnContent}
          </button>
        )}
      </div>
    </CommonModal>
  );
};

ThankYouModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  btnContent: PropTypes.string
};
